import React from "react";

const AuthContext = React.createContext();

function useAuth() {
    return React.useContext(AuthContext);
}

export { AuthContext, useAuth };